<template>
  <div class="hero">
    <VideoPlayer
      poster="/static/images/videoload.jpg"
      source="https://player.vimeo.com/external/353759764.m3u8?s=145a8e7ddd5063d5404d3194ee97e98a14af0494"
    />
    <h1>
      Passionately innovating<br />
      digital commerce since 2011<br />
      for clients such as<br />
      <span id="ticker">{{ clients[counter] }}</span>
    </h1>
    <span class="arrow">↓</span>
  </div>
</template>

<script>
import VideoPlayer from "@/components/general/VideoPlayer";

export default {
  name: "Hero",
  components: { VideoPlayer },
  data() {
    return {
      clients: [
        "Stronger",
        "Mini Rodini",
        "Röhnisch",
        "Asket",
        "EQPE",
        "OAS",
        "Miss Mary of Sweden",
        "Mateus",
        "John Henric",
        "Swims",
        "Onepiece",
        "Bambusa",
        "Xlash",
        "Odd Molly",
        "Purefun",
        "Twinroll",
        "Estrid",
        "Hunkydory",
        "House of Dagmar",
        "Eton",
        "Happy Socks",
        "Daniel Wellington",
        "Hope"
      ],
      counter: 0,
      showText: ""
    };
  },
  mounted() {
    setInterval(this.switchText, 1000);
  },
  beforeDestroy() {
    clearInterval(this.switchText);
  },
  methods: {
    switchText() {
      if (this.counter + 1 >= this.clients.length) {
        this.counter = 0;
      } else {
        this.counter++;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.hero {
  width: 100%;
  height: 100vh;
  max-height: 1000px;
  position: relative;
  top: 0;
  left: 0;
  overflow: hidden;
  background: white;
  &.active {
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
  }
  h1 {
    @include headline-medium;
    position: absolute;
    z-index: 1;
    top: 20vh;
    left: 0;
    padding: 0 5.3vw;
    color: $black;
  }
  #ticker {
    color: white;
    background: red;
    padding: 0 0.1em;
    margin-top: 0.15em;
    display: inline-block;
  }
  .arrow {
    font-weight: 300;
    font-size: 3vw;
    position: absolute;
    bottom: 10vh;
    left: 5.3vw;
    animation: float 4s ease-in-out infinite;
  }
  @keyframes float {
    0% {
      transform: translatey(0px);
    }
    50% {
      transform: translatey(-50px);
    }
    100% {
      transform: translatey(0px);
    }
  }
}
@media (max-width: $tablet) {
  .hero {
    max-height: 700px;
    h1 {
      top: 200px;
      padding: 0 50px;
      font-size: 36px;
      max-width: 500px;
      br {
        display: none;
      }
    }
    #ticker {
      display: table;
    }
    .arrow {
      font-size: 36px;
      bottom: 50px;
      left: 50px;
    }
  }
}
@media (max-width: $mobile) {
  .hero {
    h1 {
      top: 130px;
      padding: 0 30px;
    }
    .arrow {
      left: 30px;
    }
  }
}
</style>
